import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateUserGroupV3 = OpalApi<'CreateUserGroupV3', 201>

export const createUserGroup: CreateUserGroupV3 = async (args = {}) => {
  const url = new URL('/user_groups/v3/user_groups', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
